/* Delegation also supports sections refreshed by Shopify's theme editor. */
if (!window.vorsprungEnquiryHandler) {
  window.vorsprungEnquiryHandler = true;
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('#vp-preview [data-vp-finder]')) return;
    const terms = [form.querySelector('[data-vp-family]').value,
      form.querySelector('[data-vp-component]').value,
      form.querySelector('[data-vp-keyword]').value.trim()].filter(Boolean);
    event.preventDefault();
    if (!terms.length) {
      const catalogue = form.closest('#vp-preview').querySelector('.vp-featured .vp-section-heading > a');
      window.location.assign(catalogue.href);
      return;
    }
    const target = new URL(form.action, window.location.origin);
    target.searchParams.set('type', 'product');
    target.searchParams.set('q', terms.join(' '));
    window.location.assign(target.toString());
  });
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('#vp-preview [data-vp-part]');
    if (!trigger) return;
    const root = trigger.closest('#vp-preview');
    const details = root.querySelector('textarea[name="contact[body]"]');
    if (!details) return;
    const line = 'Enquiry: ' + trigger.dataset.vpPart;
    if (!details.value.includes(line)) {
      details.value = details.value ? details.value + '\n' + line : line + '\n';
    }
    details.dispatchEvent(new Event('input', { bubbles: true }));
  });
}

if (!window.vorsprungAutoScroll) {
  window.vorsprungAutoScroll = true;
  const active = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup() {
    document.querySelectorAll('#vp-preview .vp-gearbox-rail').forEach(function (rail) {
      if (active.has(rail)) return;
      rail.dataset.vpAuto = '';
      const control = document.createElement('button');
      control.type = 'button';
      control.className = 'vp-scroll-toggle';
      let paused = motion.matches;
      let hover = false;
      let holdUntil = 0;
      let direction = 1;
      let position = rail.scrollLeft;
      let last = 0;
      let frame;
      function label() {
        control.textContent = paused ? 'Play scrolling' : 'Pause scrolling';
        control.setAttribute('aria-label', control.textContent + ' for this transmission row');
      }
      label();
      rail.after(control);
      const abort = new AbortController();
      const options = { signal: abort.signal };
      control.addEventListener('click', function () { paused = !paused; label(); }, options);
      rail.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') hover = true; }, options);
      rail.addEventListener('pointerleave', function () { hover = false; }, options);
      ['pointerdown', 'touchmove', 'wheel', 'keydown'].forEach(function (name) {
        rail.addEventListener(name, function () { holdUntil = performance.now() + 5000; }, { passive: true, signal: abort.signal });
      });
      function tick(now) {
        const delta = Math.min(now - (last || now), 40);
        last = now;
        const rect = rail.getBoundingClientRect();
        const max = rail.scrollWidth - rail.clientWidth;
        if (!paused && !hover && now > holdUntil && !document.hidden && !rail.contains(document.activeElement) && rect.bottom > 0 && rect.top < window.innerHeight && max > 1 && !window.Shopify?.designMode) {
          position = Math.max(0, Math.min(max, position + direction * delta * 0.025));
          rail.scrollLeft = position;
          if (position >= max || position <= 0) { direction *= -1; holdUntil = now + 1200; }
        } else { position = rail.scrollLeft; }
        frame = requestAnimationFrame(tick);
      }
      frame = requestAnimationFrame(tick);
      active.set(rail, function () { cancelAnimationFrame(frame); abort.abort(); control.remove(); active.delete(rail); });
    });
  }
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', function (event) {
    active.forEach(function (cleanup, rail) { if (event.target.contains(rail)) cleanup(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once:true });
  else setup();
}
